import { aiServiceFetch } from "@/lib/ai-service-client";
import { HttpError } from "@/lib/http-error";
import { imagineStore } from "@/stores/imagine.store";
import type { GetProjectBillingResponseBody } from "@imagine/ai-service/shared-types/route-types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

export function BillingProvider({ children }: { children: React.ReactNode }) {
  const setBilling = imagineStore.use.billing.setBilling();
  const queryClient = useQueryClient();
  const onFinish$ = imagineStore.use.chat.onFinish$();
  const projectId = imagineStore.use.projectId();

  useQuery<GetProjectBillingResponseBody>({
    queryKey: ["billing"],
    queryFn: async () => {
      const response = await aiServiceFetch(`/api/billing`, {
        method: "GET",
      });

      if (!response.ok) {
        throw await HttpError.fromResponse(response);
      }

      const data = (await response.json()) as GetProjectBillingResponseBody;
      setBilling(data);
      return data;
    },
  });

  useEffect(() => {
    const subscription = onFinish$.subscribe(() => {
      void queryClient.invalidateQueries({ queryKey: ["billing"] });
    });
    return () => subscription.unsubscribe();
  }, [onFinish$, queryClient]);

  return <>{children}</>;
}
